import { render, staticRenderFns } from "./RoutingPage.vue?vue&type=template&id=ca48794c&"
import script from "./RoutingPage.vue?vue&type=script&lang=js&"
export * from "./RoutingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca48794c')) {
      api.createRecord('ca48794c', component.options)
    } else {
      api.reload('ca48794c', component.options)
    }
    module.hot.accept("./RoutingPage.vue?vue&type=template&id=ca48794c&", function () {
      api.rerender('ca48794c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/RoutingPage.vue"
export default component.exports